import React, { useContext, useEffect, useRef, useState } from "react";
import Input from "../../../elements/Input";
import Button from "../../../elements/Button";
import { LoginContext } from "../../../context/Login/LoginContext";
import { API_LINKS } from "../../../constant/Links";
import { ROUTES } from "../../../constant/Routes";
import { request } from "../../../utils/HttpRequest";
import Compressor from "compressorjs";
import { useNavigate } from "react-router-dom";
import { LoadingContext } from "../../../context/Loading/LoadingContext";
import { AiOutlineFileAdd } from "react-icons/ai";

const addRequest = (formData, clear, lodingContext) => {
  lodingContext.startLoading();
  request(
    API_LINKS.BASE + API_LINKS.PACKET.ADD,
    formData,
    (res) => {
      addSuccess(res, clear, lodingContext);
    },
    (error) => {
      addFailed(lodingContext);
    }
  );
};

const addSuccess = (res, clear, lodingContext) => {
  lodingContext.endLoading();
  if (res.status) {
    clear();
    alert("جواب ری با موفقیت در سیستم ثبت شد");
  } else {
    alert(res.msg);
  }
};

const addFailed = (lodingContext) => {
  lodingContext.endLoading();
  alert("اشکال در برقراری ارتباط با سرور");
};

const compresImage = (image, quality = 0.4, setFile) => {
  new Compressor(image, {
    quality: parseFloat(quality),
    success: (compressedResult) => {
      setFile(compressedResult);
      //   setShowAddPic(false);
      //   if (imageRef.current !== null) {
      //     imageRef.current.src = URL.createObjectURL(compressedResult);
      //   }
    },
  });
};

const AddPakat = (props) => {
  const navigate = useNavigate();
  const loginContext = useContext(LoginContext);
  const lodingContext = useContext(LoadingContext);

  const packetNumRef = useRef(null);
  const ayarRef = useRef(null);
  const vaznRef = useRef(null);
  const vaznSampleRef = useRef(null);
  const mobileRef = useRef(null);
  const fileInputRef = useRef(null);

  const [validate, setValidate] = useState(0);

  const [file, setFile] = useState(null);

  useEffect(() => {
    if (loginContext.userInfo != undefined) {
      lodingContext.startLoading();
      fetchPacketNumbers(loginContext.userInfo.id);
    }
  }, []);

  const fetchPacketNumbers = (labId) => {
    request(
      API_LINKS.BASE + API_LINKS.PACKET_NUMBERS.RANGE,
      {
        laboratoryId: labId,
      },
      (res) => {
        if (!res.status) {
          navigate(ROUTES.BUY_PACKET_NUMBER);
        }
        lodingContext.endLoading();
      },
      (err) => {
        alert("اشکال در برقراری ارتباط با سرور");
        lodingContext.endLoading();
      }
    );
  };

  const handleImageChoose = (event) => {
    const files = event.target.files;
    if (files.length == 0) {
      return;
    }
    const image = files[0];
    compresImage(image, 0.6, setFile);
    setValidate(0);
  };

  const clearData = () => {
    packetNumRef.current.value = "";
    ayarRef.current.value = "";
    vaznRef.current.value = "";
    vaznSampleRef.current.value = "";
    mobileRef.current.value = "";
    setFile(null);
    fileInputRef.current.value = "";
  };

  const submitHandle = () => {
    const packetNum = packetNumRef.current.value;
    const ayar = ayarRef.current.value;
    const vazn = vaznRef.current.value;
    const vaznSample = vaznSampleRef.current.value;
    const mobile = mobileRef.current.value;
    const userId = loginContext.userInfo.id;

    if (packetNum.length < 8) {
      setValidate(1);
      packetNumRef.current.focus();
      return;
    }

    console.log(parseFloat(vazn));
    if (isNaN(parseFloat(vazn)) || parseFloat(vazn) <= 0) {
      setValidate(2);
      vaznRef.current.focus();
      return;
    }

    if (ayar.length !== 3 || isNaN(parseFloat(ayar))) {
      setValidate(3);
      ayarRef.current.focus();
      return;
    }

    if (
      isNaN(parseInt(mobile)) ||
      mobile.length !== 11 ||
      mobile[0] + mobile[1] !== "09"
    ) {
      setValidate(4);
      mobileRef.current.focus();
      return;
    }

    if (file == null) {
      setValidate(5);
      return;
    }

    setValidate(0);

    const obj = {
      laboratoryId: userId,
      number: packetNum,
      cutie: ayar,
      weight: vazn,
      sampleWeight: vaznSample,
      mobile: mobile,
      pic: file,
    };

    addRequest(obj, clearData, lodingContext);
  };

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2">
        <div className="">
          <Input
            extraClass="rounded-2xl"
            type="text"
            placeHolder="شماره پاکت"
            inputMode="numeric"
            padding="p-3"
            refrence={packetNumRef}
            mode={validate === 1 ? "error" : "normal"}
            message={validate === 1 ? "شماره پاکت باید 8 رقمی باشد" : ""}
            handler={() => {
              setValidate(0);
            }}
          />
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="text"
            placeHolder="وزن کل"
            padding="p-3"
            refrence={vaznRef}
            inputMode="numeric"
            mode={validate === 2 ? "error" : "normal"}
            message={validate === 2 ? "وزن را به درستی وارد کنید" : ""}
            handler={() => {
              setValidate(0);
            }}
          />
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="text"
            placeHolder="وزن نمونه"
            inputMode="numeric"
            padding="p-3"
            refrence={vaznSampleRef}
            handler={() => {
              setValidate(0);
            }}
          />
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="text"
            placeHolder="عیار"
            inputMode="numeric"
            padding="p-3"
            refrence={ayarRef}
            mode={validate === 3 ? "error" : "normal"}
            message={validate === 3 ? "عیار را به درستی وارد کنید" : ""}
            handler={() => {
              setValidate(0);
            }}
          />
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="text"
            placeHolder="موبایل درخواست کننده"
            padding="p-3"
            inputMode="numeric"
            refrence={mobileRef}
            maxLength="11"
            mode={validate === 4 ? "error" : "normal"}
            message={validate === 4 ? "موبایل را به درستی وارد کنید" : ""}
            handler={() => {
              setValidate(0);
            }}
          />
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="file"
            placeHolder="عکس"
            padding="p-3"
            refrence={fileInputRef}
            accept="image/*,capture=camera"
            mode={validate === 5 ? "error" : "normal"}
            message={validate === 5 ? "عکس الزامی است" : ""}
            handler={handleImageChoose}
          />
        </div>
        <div className="text-center sm:col-span-2">
          <Button
            extraClass="text-darkTextPrimary my-4"
            padding="py-3 px-10"
            icon={<AiOutlineFileAdd className="text-xl" />}
            type="submit"
            variant="success"
            content="افزودن"
            rounded="rounded-2xl"
            onClick={submitHandle}
          />
        </div>
      </div>
    </>
  );
};

export default AddPakat;
